import Vue from "vue";

export default {
    state: Vue.observable({
        cart: {
            items: {},
            availableShippingMethods: {},
        },
    }),

    /*
     * --------------------------------------------------
     * Legacy Cart Compatibility
     * --------------------------------------------------
     *
     * Cart functionality is no longer used by the
     * property auction website.
     *
     * These methods are kept only so any old component
     * reference does not cause a JavaScript error.
     */

    cartIsEmpty() {
        return true;
    },

    updateCart(cart) {
        this.state.cart = cart || {
            items: {},
            availableShippingMethods: {},
        };
    },

    removeCartItem(cartItem) {
        if (
            this.state.cart &&
            this.state.cart.items &&
            cartItem &&
            cartItem.id
        ) {
            Vue.delete(this.state.cart.items, cartItem.id);
        }
    },

    clearCart() {
        if (this.state.cart) {
            this.state.cart.items = {};
        }
    },

    hasShippingMethod() {
        return false;
    },


    /*
     * --------------------------------------------------
     * Legacy Wishlist Compatibility
     * --------------------------------------------------
     *
     * Wishlist has been removed from the new property
     * platform frontend.
     */

    wishlistCount() {
        return 0;
    },

    inWishlist(productId) {
        return false;
    },

    syncWishlist(productId) {
        return false;
    },

    addToWishlist(productId) {
        return false;
    },

    removeFromWishlist(productId) {
        return false;
    },


    /*
     * --------------------------------------------------
     * Legacy Compare Compatibility
     * --------------------------------------------------
     *
     * Product comparison has been removed from the
     * property auction frontend.
     */

    inCompareList(productId) {
        return false;
    },

    syncCompareList(productId) {
        return false;
    },

    addToCompareList(productId) {
        return false;
    },

    removeFromCompareList(productId) {
        return false;
    },
};